export default class Points {
    public id: string = null;
    public points: number = null;
}